import * as API from '../utilities/api';
import { findSelectedSequence } from '../selectors/sequence';

export const RECEIVE_SEQUENCES = 'RECEIVE_SEQUENCES';
export const SELECT_SEQUENCE = 'SELECT_SEQUENCE';
export const SEQUENCE_STEP_FORWARD = 'SEQUENCE_STEP_FORWARD';
export const SEQUENCE_STEP_BACK = 'SEQUENCE_STEP_BACK';
export const CLEAR_SELECTED_SEQUENCE = 'CLEAR_SELECTED_SEQUENCE';

export function fetchSequences() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const state = getState();
      API.getSequences(state.bookingLocation.selectedLocationId)
        .then(result => {
          dispatch(receiveSequences(result));
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  };
}

export function receiveSequences(sequences) {
  return {
    type: RECEIVE_SEQUENCES,
    sequences
  };
}

export function trySelectSequence(sequence) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      selectSequenceAsync(dispatch, sequence).then(() => {
        const state = getState();
        const sequence = state.sequence.selectedSequence ? findSelectedSequence(state.sequence) : false;
        if (!sequence) reject('No selected sequence found');
      });
    });
  };
}

export function selectSequence(sequence) {
  return {
    type: SELECT_SEQUENCE,
    sequence
  };
}
export function selectSequenceAsync(dispatch, sequence) {
  dispatch(selectSequence(sequence));
  return Promise.resolve();
}

export function sequenceStepForward() {
  return {
    type: SEQUENCE_STEP_FORWARD
  }
}

export function sequenceStepBack() {
  return {
    type: SEQUENCE_STEP_BACK
  }
}

export function clearSelectedSequence() {
  return {
    type: CLEAR_SELECTED_SEQUENCE
  };
}
